import { render, staticRenderFns } from "./BonusPoints.vue?vue&type=template&id=7e013332&scoped=true&"
import script from "./BonusPoints.vue?vue&type=script&lang=js&"
export * from "./BonusPoints.vue?vue&type=script&lang=js&"
import style0 from "./BonusPoints.vue?vue&type=style&index=0&id=7e013332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e013332",
  null
  
)

export default component.exports